// src/pages/CartPage.js - Beautiful Shopping Cart with Nigerian Design
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { toast } from 'react-toastify';
import Loader from '../components/Loader';

const CartPage = () => {
  const { 
    cart, // <-- use cart, not items!
    removeFromCart, 
    updateQuantity, 
    clearCart,
    getCartTotal,
    getDeliveryFee,
    getFinalTotal,
    getCartItemCount
  } = useCart();

  const [isCheckingOut, setIsCheckingOut] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleCheckout = () => {
    setIsCheckingOut(true);
    // Simulate checkout process
    setTimeout(() => {
      toast.success('🎉 Order placed successfully! You will receive a confirmation shortly. 🇳🇬');
      clearCart();
      setIsCheckingOut(false);
    }, 2000);
  };

  const safeCart = Array.isArray(cart) ? cart : [];

  if (safeCart.length === 0) {
    return (
      <div style={{
        minHeight: '80vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #FFF8DC, #f8f9fa)',
        padding: '2rem'
      }}>
        <div style={{
          textAlign: 'center',
          background: 'white',
          padding: '4rem 3rem',
          borderRadius: '30px',
          boxShadow: '0 15px 40px rgba(0,0,0,0.1)',
          maxWidth: '500px'
        }}>
          <div style={{
            fontSize: '6rem',
            marginBottom: '2rem',
            animation: 'bounce 2s infinite'
          }}>
            🛒
          </div>
          <h2 style={{
            fontSize: '2.5rem',
            fontWeight: '900',
            color: '#008751',
            marginBottom: '1rem'
          }}>
            Your Cart is Empty
          </h2>
          <p style={{
            fontSize: '1.2rem',
            color: '#6b7280',
            marginBottom: '3rem',
            lineHeight: '1.6'
          }}>
            Looks like you haven't added any delicious Nigerian dishes yet! 
            Let's fix that right now! 🍽️
          </p>
          <Link 
            to="/menu"
            style={{
              background: 'linear-gradient(135deg, #008751, #fb923c)',
              color: 'white',
              padding: '1.2rem 3rem',
              borderRadius: '30px',
              textDecoration: 'none',
              fontWeight: '800',
              fontSize: '1.2rem',
              display: 'inline-block',
              transition: 'all 0.3s ease',
              boxShadow: '0 8px 25px rgba(0,0,0,0.15)'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-3px) scale(1.05)';
              e.target.style.boxShadow = '0 12px 35px rgba(0,0,0,0.2)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0) scale(1)';
              e.target.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
            }}
          >
            🍽️ Browse Menu
          </Link>
        </div>

        <style>{`
          @keyframes bounce {
            0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
            40% { transform: translateY(-20px); }
            60% { transform: translateY(-10px); }
          }
        `}</style>
      </div>
    );
  }

  return loading ? <Loader text="Loading menu..." /> : (
    <div className="main-container cart-page">
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 2rem'
      }}>
        {/* Header */}
        <div style={{
          textAlign: 'center',
          marginBottom: '3rem'
        }}>
          <h1 style={{
            fontSize: '3rem',
            fontWeight: '900',
            color: '#008751',
            marginBottom: '1rem'
          }}>
            🛒 Your Cart ({getCartItemCount()} items)
          </h1>
          <p style={{
            fontSize: '1.2rem',
            color: '#6b7280'
          }}>
            Review your delicious Nigerian food selection
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: '2fr 1fr',
          gap: '3rem',
          alignItems: 'start'
        }}>
          {/* Cart Items */}
          <div>
            <div style={{
              background: 'white',
              borderRadius: '25px',
              padding: '2rem',
              boxShadow: '0 12px 30px rgba(0,0,0,0.1)'
            }}>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '2rem',
                paddingBottom: '1rem',
                borderBottom: '2px solid #f8f9fa'
              }}>
                <h2 style={{
                  fontSize: '1.5rem',
                  fontWeight: '800',
                  color: '#008751'
                }}>
                  Order Items
                </h2>
                <button
                  onClick={clearCart}
                  style={{
                    background: 'transparent',
                    border: '2px solid #ff4757',
                    color: '#ff4757',
                    padding: '0.5rem 1rem',
                    borderRadius: '15px',
                    fontWeight: '700',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.background = '#ff4757';
                    e.target.style.color = 'white';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.background = 'transparent';
                    e.target.style.color = '#ff4757';
                  }}
                >
                  🗑️ Clear All
                </button>
              </div>

              {/* Cart Items List */}
              <div className="cart-items-list" style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                {safeCart.map(item => (
                  <div key={item.id} style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1.5rem',
                    padding: '1.5rem',
                    background: '#f8f9fa',
                    borderRadius: '20px',
                    border: '2px solid transparent',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.borderColor = '#fb923c';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.borderColor = 'transparent';
                    e.target.style.transform = 'translateY(0)';
                  }}
                  >
                    {/* Food Emoji */}
                    <div style={{
                      fontSize: '3rem',
                      minWidth: '80px',
                      textAlign: 'center'
                    }}>
                      {item.emoji}
                    </div>

                    {/* Item Details */}
                    <div style={{ flex: 1 }}>
                      <h3 style={{
                        fontSize: '1.3rem',
                        fontWeight: '800',
                        color: '#008751',
                        marginBottom: '0.5rem'
                      }}>
                        {item.name}
                      </h3>
                      <p style={{
                        color: '#6b7280',
                        fontSize: '0.9rem',
                        marginBottom: '0.5rem'
                      }}>
                        {item.description}
                      </p>
                      <div style={{
                        fontSize: '1.2rem',
                        fontWeight: '900',
                        color: '#fb923c'
                      }}>
                        ₦{item.price.toLocaleString()} each
                      </div>
                    </div>

                    {/* Quantity Controls */}
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '1rem',
                      background: 'white',
                      padding: '0.5rem',
                      borderRadius: '15px',
                      boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
                    }}>
                      <button
                        onClick={() => updateQuantity(item.id, item.quantity - 1)}
                        style={{
                          background: '#ff4757',
                          color: 'white',
                          border: 'none',
                          borderRadius: '50%',
                          width: '35px',
                          height: '35px',
                          cursor: 'pointer',
                          fontWeight: '900',
                          fontSize: '1.2rem',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          transition: 'all 0.3s ease'
                        }}
                        onMouseOver={(e) => e.target.style.transform = 'scale(1.1)'}
                        onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                      >
                        −
                      </button>
                      
                      <span style={{
                        fontSize: '1.3rem',
                        fontWeight: '800',
                        color: '#008751',
                        minWidth: '40px',
                        textAlign: 'center'
                      }}>
                        {item.quantity}
                      </span>
                      
                      <button
                        onClick={() => updateQuantity(item.id, item.quantity + 1)}
                        style={{
                          background: '#22c55e',
                          color: 'white',
                          border: 'none',
                          borderRadius: '50%',
                          width: '35px',
                          height: '35px',
                          cursor: 'pointer',
                          fontWeight: '900',
                          fontSize: '1.2rem',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          transition: 'all 0.3s ease'
                        }}
                        onMouseOver={(e) => e.target.style.transform = 'scale(1.1)'}
                        onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                      >
                        +
                      </button>
                    </div>

                    {/* Item Total */}
                    <div style={{
                      fontSize: '1.4rem',
                      fontWeight: '900',
                      color: '#008751',
                      minWidth: '120px',
                      textAlign: 'right'
                    }}>
                      ₦{(item.price * item.quantity).toLocaleString()}
                    </div>

                    {/* Remove Button */}
                    <button
                      onClick={() => {
                        removeFromCart(item.id);
                        toast.info('Removed from cart.');
                      }}
                      style={{
                        background: 'transparent',
                        border: 'none',
                        color: '#ff4757',
                        fontSize: '1.5rem',
                        cursor: 'pointer',
                        padding: '0.5rem',
                        borderRadius: '10px',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseOver={(e) => {
                        e.target.style.background = '#ff4757';
                        e.target.style.color = 'white';
                        e.target.style.transform = 'scale(1.1)';
                      }}
                      onMouseOut={(e) => {
                        e.target.style.background = 'transparent';
                        e.target.style.color = '#ff4757';
                        e.target.style.transform = 'scale(1)';
                      }}
                    >
                      🗑️
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Order Summary */}
          <div style={{
            background: 'white',
            borderRadius: '25px',
            padding: '2rem',
            boxShadow: '0 12px 30px rgba(0,0,0,0.1)',
            position: 'sticky',
            top: '2rem'
          }}>
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: '800',
              color: '#008751',
              marginBottom: '2rem',
              textAlign: 'center'
            }}>
              🧾 Order Summary
            </h2>

            {/* Summary Details */}
            <div style={{ marginBottom: '2rem' }}>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1rem'
              }}>
                <span style={{ color: '#6b7280', fontWeight: '600' }}>
                  Subtotal ({getCartItemCount()} items)
                </span>
                <span style={{ fontWeight: '800', color: '#374151' }}>
                  ₦{getCartTotal().toLocaleString()}
                </span>
              </div>

              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1rem'
              }}>
                <span style={{ color: '#6b7280', fontWeight: '600' }}>
                  Delivery Fee
                </span>
                <span style={{ 
                  fontWeight: '800', 
                  color: getDeliveryFee() === 0 ? '#22c55e' : '#374151'
                }}>
                  {getDeliveryFee() === 0 ? 'FREE 🎉' : `₦${getDeliveryFee().toLocaleString()}`}
                </span>
              </div>

              {getCartTotal() >= 5000 && (
                <div style={{
                  background: 'linear-gradient(135deg, #22c55e, #16a34a)',
                  color: 'white',
                  padding: '0.8rem',
                  borderRadius: '15px',
                  textAlign: 'center',
                  fontSize: '0.9rem',
                  fontWeight: '700',
                  marginBottom: '1rem'
                }}>
                  🎉 You got FREE delivery!
                </div>
              )}

              <div style={{
                borderTop: '2px solid #f8f9fa',
                paddingTop: '1rem',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}>
                <span style={{ 
                  fontSize: '1.2rem',
                  fontWeight: '900', 
                  color: '#008751' 
                }}>
                  Total
                </span>
                <span style={{ 
                  fontSize: '1.5rem',
                  fontWeight: '900', 
                  color: '#fb923c' 
                }}>
                  ₦{getFinalTotal().toLocaleString()}
                </span>
              </div>
            </div>

            {/* Checkout Button */}
            <Link
              to="/checkout"
              style={{
                display: 'block',
                width: '100%',
                background: 'linear-gradient(135deg, #008751, #fb923c)',
                color: 'white',
                border: 'none',
                padding: '1.5rem',
                borderRadius: '20px',
                fontWeight: '900',
                fontSize: '1.2rem',
                cursor: 'pointer',
                textAlign: 'center',
                marginBottom: '1rem',
                textDecoration: 'none',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={e => {
                e.target.style.transform = 'translateY(-3px)';
                e.target.style.boxShadow = '0 15px 35px rgba(0, 135, 81, 0.4)';
              }}
              onMouseOut={e => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = 'none';
              }}
            >
              🚀 Proceed to Checkout
            </Link>

            {/* Continue Shopping */}
            <Link 
              to="/menu"
              style={{
                display: 'block',
                textAlign: 'center',
                color: '#6b7280',
                textDecoration: 'none',
                fontWeight: '700',
                padding: '1rem',
                borderRadius: '15px',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={(e) => {
                e.target.style.background = '#f8f9fa';
                e.target.style.color = '#008751';
              }}
              onMouseOut={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.color = '#6b7280';
              }}
            >
              ← Continue Shopping
            </Link>
          </div>
        </div>
      </div>

      {/* Mobile Responsive Styles */}
      <style>{`
        .main-container.cart-page {
          box-sizing: border-box;
          width: 100%;
          max-width: 100vw;
          overflow-x: hidden;
        }
        .cart-items-list {
          width: 100%;
        }
        @media (max-width: 900px) {
          .main-container.cart-page > div {
            padding: 0 0.5rem !important;
          }
          .main-container.cart-page > div > div {
            grid-template-columns: 1fr !important;
            gap: 2rem !important;
          }
        }
        @media (max-width: 600px) {
          .main-container.cart-page > div {
            padding: 0 0.2rem !important;
          }
          .main-container.cart-page > div > div {
            grid-template-columns: 1fr !important;
            gap: 1rem !important;
          }
          .cart-items-list > div {
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 0.7rem !important;
            padding: 1rem !important;
          }
          .cart-items-list h3 {
            font-size: 1.05rem !important;
          }
          .cart-items-list p {
            font-size: 0.85rem !important;
          }
          .cart-items-list > div > div[style*="font-size: 3rem"] {
            font-size: 2rem !important;
            min-width: 50px !important;
          }
          .cart-items-list > div > div[style*="font-size: 1.4rem"] {
            font-size: 1.1rem !important;
            min-width: 80px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default CartPage;